import { buildStyledComponent } from 'decisiv-ui-utils';
import PropTypes from 'prop-types';
import styled from 'styled-components';

/* istanbul ignore next */
const modifierConfig = {
  selected: ({ theme }) => ({ styles: `background: ${theme.colors.status.successBackground};` }),
};

/* istanbul ignore next */
const styles = ({ theme }) => `
  border-top: 1px solid ${theme.colors.base.chrome200};
`;

const themePropTypes = {
  colors: PropTypes.shape({
    base: PropTypes.shape({
      chrome200: PropTypes.string.isRequired,
    }).isRequired,
    status: PropTypes.shape({
      successBackground: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default buildStyledComponent(
  'ScrollableContainer.ListElement',
  styled.li,
  styles,
  { modifierConfig, themePropTypes },
);



// WEBPACK FOOTER //
// ./elements/ScrollableContainer/ListElement.js